import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Timeout } from '../../../actions/cart.js';
import { Ajax } from '../../../classes/ajax.js';
import { ModalDialog } from '../../../components/dialogs/ModalDialog.js';
import { useCartExpiration } from '../../../hooks/useCartExpiration.js';
import { isCheckout, translate } from '../../../utils/wp.js';

export function CartExpirationController() {
    const {state} = useCartExpiration();

    const dispatch = useDispatch();

    function onClickStartOver() {
        localStorage.removeItem('persist:cart');
        document.location.reload();
    }

    useEffect(() => {
        if (state !== 'expired' || !isCheckout()) {
            return;
        }

        new Ajax(
            'POST_WORDPRESS',
            NOJESRESOR_WORDPRESS.ajaxurl + '/empty_cart',
            {
                security: application.nonce,
                action: 'nch_empty_cart',
            },
        )
            .then(() => {
                dispatch(Timeout());
                history.back();
            })
            .catch(() => null);
    }, [state]);

    return (
        <ModalDialog
            visible={state === 'expired'}
            primaryAction={onClickStartOver}
            primaryActionText={!isCheckout() &&
                translate('timeout_dialog_primary_action')}
            secondaryAction={onClickStartOver}
            icon={'clock'}
            header={translate('timeout_dialog_title')}
            body={translate('timeout_dialog_content')}
        />
    );
}
